// Maps a team's `internationalName` (as sent by the backend, which derives it from FIFA's
// English team name — see Analysis/AnalysisProvider/Services/FifaMatchesService.cs) to a
// circle-flag country code (ISO 3166-1 alpha-2, plus gb-eng / gb-sct for home nations).
// Codes resolve to local SVGs under public/images/flags/<code>.svg via src/common/CircleFlag.
//
// FIFA's exact spellings vary for some nations, so where there is ambiguity we register
// multiple aliases pointing at the same flag (e.g. "Korea Republic" and "South Korea") so the
// flag resolves whichever form the feed returns. Unknown names fall back to "pl" at the call site.

let CountryDict = new Map<string, string>();

// --- 2026 FIFA World Cup teams ---
// Hosts
CountryDict.set("Mexico", "mx");
CountryDict.set("Canada", "ca");
CountryDict.set("USA", "us");
CountryDict.set("United States", "us");

// UEFA
CountryDict.set("Spain", "es");
CountryDict.set("France", "fr");
CountryDict.set("England", "gb-eng");
CountryDict.set("Portugal", "pt");
CountryDict.set("Netherlands", "nl");
CountryDict.set("Belgium", "be");
CountryDict.set("Germany", "de");
CountryDict.set("Croatia", "hr");
CountryDict.set("Switzerland", "ch");
CountryDict.set("Austria", "at");
CountryDict.set("Norway", "no");
CountryDict.set("Sweden", "se");
CountryDict.set("Scotland", "gb-sct");
CountryDict.set("Czechia", "cz");
CountryDict.set("Türkiye", "tr");
CountryDict.set("Turkey", "tr");
CountryDict.set("Bosnia", "ba");
CountryDict.set("Bosnia and Herzegovina", 'ba');
// CONMEBOL
CountryDict.set("Argentina", "ar");
CountryDict.set("Brazil", "br");
CountryDict.set("Uruguay", "uy");
CountryDict.set("Colombia", "co");
CountryDict.set("Ecuador", "ec");
CountryDict.set("Paraguay", "py");

// CONCACAF
CountryDict.set("Panama", "pa");
CountryDict.set("Haiti", "ht");
CountryDict.set("Curaçao", "cw");
CountryDict.set("Curacao", "cw");

// AFC
CountryDict.set("Japan", "jp");
CountryDict.set("Korea Republic", "kr");
CountryDict.set("South Korea", "kr");
CountryDict.set("IR Iran", "ir");
CountryDict.set("Iran", "ir");
CountryDict.set("Australia", "au");
CountryDict.set("Saudi Arabia", "sa");
CountryDict.set("Qatar", "qa");
CountryDict.set("Uzbekistan", "uz");
CountryDict.set("Jordan", "jo");
CountryDict.set("Iraq", "iq");

// CAF
CountryDict.set("Morocco", "ma");
CountryDict.set("Senegal", "sn");
CountryDict.set("Tunisia", "tn");
CountryDict.set("Egypt", "eg");
CountryDict.set("Algeria", "dz");
CountryDict.set("Côte d'Ivoire", "ci");
CountryDict.set("Cote d'Ivoire", "ci");
CountryDict.set("Ivory Coast", "ci");
CountryDict.set("Ghana", "gh");
CountryDict.set("Cabo Verde", "cv");
CountryDict.set("Cape Verde", "cv");
CountryDict.set("South Africa", "za");
CountryDict.set("Congo DR", "cd");
CountryDict.set("DR Congo", "cd");
CountryDict.set("Democratic Republic of the Congo", "cd");

// OFC
CountryDict.set("New Zealand", "nz");

// --- Other nations kept for reference / non-WC fixtures (harmless if unused) ---
CountryDict.set("Poland", "pl");
CountryDict.set("Serbia", "rs");
CountryDict.set("Denmark", "dk");
CountryDict.set("Hungary", "hu");
CountryDict.set("Slovakia", "sk");
CountryDict.set("Albania", "al");
CountryDict.set("Romania", "ro");
CountryDict.set("Italy", "it");
CountryDict.set("Slovenia", "si");
CountryDict.set("Georgia", "ge");
CountryDict.set("Ukraine", "ua");

export default CountryDict;
